import { normalizeProfileCountry } from "../constants/profileLocations";

// These are full municipality names from the Russian profile city picker.
// Short names such as "Rostov" are deliberately absent: they can identify
// another city and must not be guessed from the spelling alone.
const RU_CITY_LABELS = new Map([
  ["Yekaterinburg", "Екатеринбург"],
  ["Moscow", "Москва"],
  ["Saint Petersburg", "Санкт-Петербург"],
  ["Novosibirsk", "Новосибирск"],
  ["Kazan", "Казань"],
  ["Nizhny Novgorod", "Нижний Новгород"],
  ["Chelyabinsk", "Челябинск"],
  ["Samara", "Самара"],
  ["Ufa", "Уфа"],
  ["Rostov-on-Don", "Ростов-на-Дону"],
  ["Perm", "Пермь"],
  ["Tyumen", "Тюмень"],
  ["Omsk", "Омск"],
  ["Krasnoyarsk", "Красноярск"],
  ["Krasnodar", "Краснодар"],
  ["Voronezh", "Воронеж"],
  ["Volgograd", "Волгоград"],
  ["Saratov", "Саратов"],
  ["Tolyatti", "Тольятти"],
  ["Izhevsk", "Ижевск"],
  ["Barnaul", "Барнаул"],
  ["Ulyanovsk", "Ульяновск"],
  ["Irkutsk", "Иркутск"],
  ["Khabarovsk", "Хабаровск"],
  ["Vladivostok", "Владивосток"],
  ["Yaroslavl", "Ярославль"],
  ["Makhachkala", "Махачкала"],
  ["Tomsk", "Томск"],
  ["Kaliningrad", "Калининград"],
]);

const cityKey = (value) =>
  String(value || "")
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[‐‑‒–—―]/g, "-")
    .replace(/\s+/g, " ")
    .toLocaleLowerCase();

const RU_CANONICAL_BY_KEY = new Map();
for (const [canonical, localized] of RU_CITY_LABELS) {
  RU_CANONICAL_BY_KEY.set(cityKey(canonical), canonical);
  RU_CANONICAL_BY_KEY.set(cityKey(localized), canonical);
}
RU_CANONICAL_BY_KEY.set("ekaterinburg", "Yekaterinburg");
RU_CANONICAL_BY_KEY.set("moskva", "Moscow");
RU_CANONICAL_BY_KEY.set("nizhnij novgorod", "Nizhny Novgorod");
RU_CANONICAL_BY_KEY.set("nizhniy novgorod", "Nizhny Novgorod");

export const normalizeSelectedEventCity = (country, value) => {
  const city = String(value || "").split(",")[0].trim();
  if (normalizeProfileCountry(country) !== "RU") return city;
  return RU_CANONICAL_BY_KEY.get(cityKey(city)) || city;
};

export const localizeRussianEventCity = (value) => {
  const city = String(value || "").trim();
  const canonical = normalizeSelectedEventCity("RU", city);
  return RU_CITY_LABELS.get(canonical) || city;
};
